import { FC, useState } from "react";
import {
  Box,
  DialogActions,
  DialogContent,
  FormControl,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@material-ui/core";
import { closeDrawer } from "actions/drawerActions";
import { useDispatch } from "react-redux";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { useStyles } from "../../../pages/DaAndFleets/styles";
import { OnChangeEvent } from "types/general";
import { FleetData } from "types/DaAndFleet";
import { StationSelect } from "componentsNew/elements/SelectField";
import { fleetStatusConstants, outOfServiceReasonConstants } from "constants/constants";
import { EditFleetAction } from "actions/daAndFleetActions";
import { DateTime } from "luxon";
import useResize from "hooks/useResize";

interface FleetEditDrawerContentProps {
  data: FleetData;
}

export const FleetEditDrawerContent: FC<FleetEditDrawerContentProps> = ({ data }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { width } = useResize();
  const [subVendor, setSubVendor] = useState<string>(data.subtype || "");
  const [status, setStatus] = useState<number>(data.status || 0);
  const [statusReason, setStatusReason] = useState<number>(data.status_change_reason || 0);
  const [station, setStation] = useState<number>(data.station || 0);
  const [comment, setComment] = useState<string>(data.comment || "");

  const closenModal = () => dispatch(closeDrawer());

  const handleFilterSubmit = () => {
    dispatch(EditFleetAction(data.id, {
      subtype: subVendor,
      status: status,
      status_change_reason: statusReason,
      station: station,
      comment: comment,
    }))
    closenModal();
  };
  

  return (
    <>
      <DialogContent className={classes.drawerContent}>
        <FormControl fullWidth>
          <Typography className={classes.textareaLabel}>Fleet Sub Vendor</Typography>
          <OutlinedInput
            value={subVendor}
            onChange={(e: OnChangeEvent) => setSubVendor(e.target.value)}
          />
        </FormControl>
        <FormControl fullWidth className={classes.formSection}>
          <Typography className={classes.textareaLabel}>Status</Typography>
          <Select
            fullWidth
            variant="outlined"
            value={status}
            onChange={(e: OnChangeEvent) => setStatus(e.target.value)}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  width: 840 > width ? 340 : 200,
                },
              },
              variant: "menu",
              getContentAnchorEl: null,
              anchorOrigin: { vertical: "bottom", horizontal: "center" },
              transformOrigin: { vertical: "top", horizontal: "center" },
            }}
          >
            {fleetStatusConstants.map((status) => (
              <MenuItem key={status.value} value={status.value}>
                <ListItemText primary={status.option} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth className={classes.formSection}>
          <Typography className={classes.textareaLabel}>Service Reason</Typography>
          <Select
            fullWidth
            variant="outlined"
            value={statusReason}
            onChange={(e: OnChangeEvent) => setStatusReason(e.target.value)}
            renderValue={(value) => status === 2 ? outOfServiceReasonConstants.find((reason) => reason.value === value)?.option : ""}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  width: 840 > width ? 340 : 200,
                },
              },
              variant: "menu",
              getContentAnchorEl: null,
              anchorOrigin: { vertical: "bottom", horizontal: "center" },
              transformOrigin: { vertical: "top", horizontal: "center" },
            }}
            disabled={status !== 2}
          >
            {outOfServiceReasonConstants.map((reason) => (
              <MenuItem key={reason.value} value={reason.value}>
                <ListItemText primary={reason.option} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth className={classes.formSection}>
          <StationSelect
            value={station}
            onChange={(data: string) => setStation(Number(data))}
            fullWidth
          />
        </FormControl>
        <FormControl fullWidth className={classes.formSection}>
          <Typography className={classes.textareaLabel}>Comment</Typography>
          <OutlinedInput
            className={`${classes.textarea}`}
            name="edit_comment"
            multiline
            defaultValue={comment}
            onChange={(e) => setComment(e.target.value)}
            minRows={6}
            maxRows={6}
          />
        </FormControl>
      </DialogContent>

      <DialogActions className={classes.actionSection}>
        <Typography className={classes.editedMessage}>
          {data?.last_edited_by
            ? `Last updated by ${data?.last_edited_by} on ${DateTime.fromISO(String(data.last_edit?.split("T0")[0]) || "").toFormat("dd-MM-yyyy")}`
            : ""}
        </Typography>
        <Box className={classes.actionButtons}>
          <Box className={classes.actionButtonsLeft}>
            <CustomButton
              buttonText={"Save"}
              
              onClick={handleFilterSubmit}
              variant="contained"
              customClass={classes.drawerButton}
            />
            <CustomButton
              buttonText={"Cancel"}
              onClick={closenModal}
              variant="text"
              customClass={classes.drawerButton}
            />
          </Box>
        </Box>
      </DialogActions>
    </>
  );
};
